import { render, staticRenderFns } from "./nav-panel.vue?vue&type=template&id=bd7a36c6"
import script from "./nav-panel.vue?vue&type=script&lang=js"
export * from "./nav-panel.vue?vue&type=script&lang=js"
import style0 from "./nav-panel.vue?vue&type=style&index=0&id=bd7a36c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports